import { Star } from "lucide-react";
import { REVIEWS, SITE } from "../lib/site";

export default function ReviewsSection({ compact = false, max }) {
  const list = max ? REVIEWS.slice(0, max) : REVIEWS;
  return (
    <section className="bg-[#E8DCC9]/40 border-y border-[#D5CABD]" data-testid="reviews-section">
      <div className={`container-x ${compact ? "py-14" : "py-20"}`}>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <div className="eyebrow mb-3">Avis clients vérifiés</div>
            <h2 className="text-3xl sm:text-4xl font-serif font-semibold text-gray-900">
              Une réputation construite chantier après chantier.
            </h2>
            <div className="flex items-center gap-3 mt-3 text-sm text-gray-700">
              <div className="flex gap-0.5 text-[#7A2E39]">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star key={i} className="w-4 h-4 fill-[#7A2E39]" />
                ))}
              </div>
              <strong className="text-gray-900">5,0 / 5</strong>
              <span className="text-gray-600">— Avis Google ({SITE.aggregateRating.count})</span>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((r, i) => (
            <article
              key={i}
              className="bg-white border border-[#D5CABD] p-6 rounded-sm"
              data-testid={`review-card-${i}`}
            >
              <div className="flex gap-0.5 text-[#7A2E39] mb-3">
                {Array.from({ length: r.rating }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-[#7A2E39]" />
                ))}
              </div>
              <p className="text-gray-800 leading-relaxed mb-4">« {r.text} »</p>
              <div className="text-xs uppercase tracking-widest text-gray-500">
                {r.name} · {r.city} · {new Date(r.date + "-01").toLocaleDateString("fr-FR", { month: "long", year: "numeric" })}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
